// src/components/image-dashboard/ImageGrid.jsx
import { useState } from "react";
import { DragDropContext, Droppable, Draggable } from "@hello-pangea/dnd";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import PreviewModal from "./PreviewModal";
import DeleteModal from "./DeleteModal";

const ImageGrid = ({
    images = [],      // <-- array of strings
    baseURL,
    api,
    allowReorder = false,
    reorderEndpoint,
    renameEndpoint,
    deleteHandler,
    onRenameSuccess,
    onClientReorder,
    refreshImages
}) => {

    const axiosPrivate = useAxiosPrivate();
    const [previewUrl, setPreviewUrl] = useState(null);
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [pendingDelete, setPendingDelete] = useState(null);

    const filenames = images; // strings

    const onDragEnd = async (result) => {
        if (!allowReorder || !result.destination) return;

        const items = Array.from(filenames);
        const [removed] = items.splice(result.source.index, 1);
        items.splice(result.destination.index, 0, removed);

        onClientReorder(items);

        try {
            await axiosPrivate.post(reorderEndpoint, { filenames: items });
            refreshImages();
        } catch (err) {
            console.error("Reorder failed", err);
        }
    };

    const askDelete = (filename) => {
        setPendingDelete(filename);
        setDeleteModalOpen(true);
    };

    /*
    const handleRename = async (oldName) => {
        const base = oldName.replace(/\.[^/.]+$/, "");
        const newNameNoExt = prompt("Enter new name (without extension)", base);
        if (!newNameNoExt) return;

        try {
            const res = await axiosPrivate.post(renameEndpoint, {
                oldName,
                newName: newNameNoExt
            });

            onRenameSuccess(oldName, res.data.newName);
            refreshImages();
            alert("Renamed");
        } catch (err) {
            console.error(err);
            alert("Rename failed");
        }
    };*/

    return (
        <div className="imageGrid">
            <DragDropContext onDragEnd={onDragEnd}>
                <Droppable droppableId="images" direction="horizontal">
                    {(provided) => (
                        <div className="gridRow" ref={provided.innerRef} {...provided.droppableProps}>
                            {images.map((filename, index) => (
                                <Draggable
                                    key={filename}
                                    draggableId={String(filename)}   // ✔ valid draggableId
                                    index={index}
                                    isDragDisabled={!allowReorder}
                                >
                                    {(prov, snapshot) => (
                                        <div
                                            className="imageItem"
                                            ref={prov.innerRef}
                                            {...prov.draggableProps}
                                            {...(allowReorder ? prov.dragHandleProps : {})}
                                            style={{
                                                ...prov.draggableProps.style,
                                                opacity: snapshot.isDragging ? 0.7 : 1
                                            }}
                                        >
                                            <img
                                                src={`${baseURL}${api}/${filename}`}
                                                alt={filename}
                                                onClick={() =>
                                                    setPreviewUrl(`${baseURL}${api}/${filename}`)
                                                }
                                                onError={(e) => {
                                                    e.target.style.opacity = "0.2";
                                                    e.target.style.background = "#222";
                                                }}
                                            />

                                            <div className="controls">
                                                <button onClick={() => askDelete(filename)}>
                                                    🗑 Delete
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                </Draggable>
                            ))}

                            {provided.placeholder}
                        </div>
                    )}
                </Droppable>
            </DragDropContext>

            {previewUrl && (
                <PreviewModal url={previewUrl} onClose={() => setPreviewUrl(null)} />
            )}

            <DeleteModal
                isOpen={deleteModalOpen}
                filename={pendingDelete}
                onCancel={() => setDeleteModalOpen(false)}
                onConfirm={() => {
                    deleteHandler(pendingDelete);
                    setDeleteModalOpen(false);
                }}
            />
        </div>
    );
};

export default ImageGrid;
